import { render, staticRenderFns } from "./SingleListItem.vue?vue&type=template&id=2c0af376&scoped=true"
import script from "./SingleListItem.vue?vue&type=script&lang=js"
export * from "./SingleListItem.vue?vue&type=script&lang=js"
import style0 from "./SingleListItem.vue?vue&type=style&index=0&id=2c0af376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0af376",
  null
  
)

export default component.exports